import { useRef } from "react"

export default function useFocus() {
  const htmlElRef = useRef(null)

  const setFocus = () => {
    if (htmlElRef.current) {
      htmlElRef.current.focus({ preventScroll: true })
      htmlElRef.current.scrollIntoView({ behavior: "smooth", block: "end" })
    }
  }

  return [htmlElRef, setFocus]
}
